import { useState } from "react"

export default function PaymentSucces() {
    return <>
        <div className="px-[20px] lg:px-[80px] pt-28">
            پرداخت با موفقیت انجام شد
        </div>
    </>
}